module.exports = __webpack_public_path__ + "static/media/payment-slip-icon.03682267.svg";